export const availableGames: { name: string; url: string }[] = [
  { name: 'Tik-Tak-Boom', url: '/tik-tak-boom' },
  { name: 'Pantomime', url: '/pantomime' }
];
